const column = [
  {
    name:'首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[
      {
        name:'专业介绍',
        to:'/desc',
        type:1,
        params:{
          id:49
        },
      },
    ],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学校概况',
    to:'',
    type:2,
    img:'b01.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'学校简介',
        to:'/evn/content',
        type:1,
        params:{
          id:8
        },
      },
      {
        name:'办学理念',
        to:'/evn/content',
        type:1,
        params:{
          id:237
        },
      },
      {
        name:'领导关怀',
        to:'/evn/list',
        type:2,
        params:{
          id:77
        },
      },
      {
        name:'现任领导',
        to:'/evn/list',
        type:2,
        params:{
          id:11,
          template:'teacher'
        },
      },
      {
        name:'思政党建',
        to:'/evn/list',
        type:2,
        params:{
          id:67,
          template:'media'
        },
      },
      {
        name:'组织机构',
        to:'/evn/content',
        type:1,
        params:{
          id:7
        },
      },
      {
        name:'交通指引',
        to:'/evn/content',
        type:1,
        params:{
          id:151
        },
      },
      {
        name:'学校风光',
        to:'/evn/list',
        type:2,
        params:{
          id:17,
          template:'nev'
        },
      },
    ],
  },
  {
    name:'学校动态',
    to:'',
    type:2,
    img:'b02.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'学校要闻',//学校新闻
        to:'/evn/list',
        type:2,
        params:{
          id:18,
          template:'xnews'
        },
      },
      {
        name:'通知公告',
        to:'/evn/list',
        type:2,
        params:{
          id:19,
          template:'notice'
        },
      },
      {
        name:'职教动态',
        to:'/evn/list',
        type:2,
        params:{
          id:68,
          template:'notice'
        },
      },
      {
        name:'部门动态',
        to:'/evn/list',
        type:2,
        params:{
          id:76,
          template:'notice'
        },
      },
      {
        name:'媒体聚焦',
        to:'/evn/list',
        type:2,
        params:{
          id:20,
          template:'media'
        },
      },
      {
        name:'信息公开',
        to:'/evn/list',
        type:2,
        params:{
          id:84,
          template:'media'
        },
      },
    ],
  },
  {
    name:'教学科研',
    to:'',
    type:2,
    img:'b04.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'人才培养',
        to:'/evn/list',
        type:2,
        params:{
          id:80,
          template:'media'
        },
      },
      {
        name:'教研动态',//原本是教学动态
        to:'/evn/list',
        type:2,
        params:{
          id:81,
          template:'media'
        },
      },
      {
        name:'教学信息',
        to:'/evn/list',
        type:2,
        params:{
          id:82,
          template:'media'
        },
      },
      {
        name:'实训基地',
        to:'/evn/list',
        type:2,
        params:{
          id:69,
          template:'media'
        },
      },
      {
        name:'技能竞赛',//双创与竞赛
        to:'/evn/list',
        type:2,
        params:{
          id:83,
          template:'media'
        },
      },
      {
        name:'质量管理',
        to:'/evn/list',
        type:2,
        params:{
          id:70,
          template:'media'
        },
      },

    ],
  },
  {
    name:'院系风采',
    to:'',
    type:2,
    img:'b03.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'智能制造系',
        to:'/evn/list',
        type:2,
        params:{
          id:72,
          template:'media'
        },
      },
      {
        name:'现代服务系',
        to:'/evn/list',
        type:2,
        params:{
          id:73,
          template:'media'
        },
      },
      {
        name:'数字经济系',
        to:'/evn/list',
        type:2,
        params:{
          id:74,
          template:'media'
        },
      },
      {
        name:'专业介绍',
        to:'/evn/list',
        type:2,
        params:{
          id:49,
          template:'media'
        },
      },
      {
        name:'教师风采',
        to:'/evn/list',
        type:2,
        params:{
          id:75,
          template:'media'
        },
      },
    ],
  },
  {
    name:'招生就业',
    to:'/enroll',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{},
    img:'b05.jpg',
    introduce:''
  },
  {
    name:'德育经纬',
    to:'',
    type:2,
    img:'b06.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'学工动态',
        to:'/evn/list',
        type:2,
        params:{
          id:33,
          template:'media'
        },
      },
      {
        name:'团学在线',
        to:'/evn/list',
        type:2,
        params:{
          id:86,
          template:'media'
        },
      },
      {
        name:'社区书院',
        to:'/evn/list',
        type:2,
        params:{
          id:87,
          template:'star'
        },
      },
      {
        name:'事务中心',
        to:'/evn/list',
        type:2,
        params:{
          id:88,
          template:'star'
        },
      },
      {
        name:'制度园地',
        to:'/evn/list',
        type:2,
        params:{
          id:89,
          template:'star'
        },
      },
      {
        name:'主题班会',
        to:'/evn/list',
        type:2,
        params:{
          id:90,
          template:'star'
        },
      },
      {
        name:'安全讲堂',
        to:'/evn/list',
        type:2,
        params:{
          id:91,
          template:'star'
        },
      },{
        name:'下载专区',
        to:'/evn/list',
        type:2,
        params:{
          id:92,
          template:'star'
        },
      }

    ],
  },
  {
    name:'产业赋能',
    to:'',
    type:2,
    img:'b07.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'技能培训',
        to:'/evn/list',
        type:2,
        params:{
          id:41,
          template:'media'
        },
      },
      {
        name:'技能鉴定',
        to:'/evn/list',
        type:2,
        params:{
          id:42,
          template:'media'
        },
      },
      {
        name:'公共实训',
        to:'/evn/list',
        type:2,
        params:{
          id:43,
          template:'media'
        },
      },
      {
        name:'技师研修',
        to:'/evn/list',
        type:2,
        params:{
          id:44,
          template:'media'
        },
      },
      {
        name:'学历提升',
        to:'/evn/list',
        type:2,
        params:{
          id:45,
          template:'media'
        },
      },
      {
        name:'创新孵化',
        to:'/evn/list',
        type:2,
        params:{
          id:46,
          template:'media'
        },
      },
      {
        name:'竞赛集训',
        to:'/evn/list',
        type:2,
        params:{
          id:47,
          template:'media'
        },
      },
      {
        name:'产教融合',
        to:'/evn/list',
        type:2,
        params:{
          id:48,
          template:'newx'
        },
      },
    ],
  },
  {
    name:'山海匠心',
    to:'/',
    type:2,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    params:{},
    img:'b08.jpg',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'山海匠心',
        to:'/evn/list',
        type:2,
        params:{
          id:85,
          template:'media'
        },
      },
    ],
  },
  {
    name:'公共服务',
    to:'',
    type:9,
    img:'',
    introduce:'坚持“以生为本、质量强校”的办学方针',
    children:[
      {
        name:'学期日历',
        to:'/evn/list',
        type:2,
        params:{
          id:61,
          template:'media'
        },
      },
    ],
  },
];

const enrollColumn = [
  {
    name:'本站首页',
    to:'/enroll/index',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学校概况',
    to:'/evn/content?id=0&pid=1',
    type:1,
    children:[],
    img:'',
    introduce:'',
    params:{
      id:0
    },
  },
  {
    name:'招生信息',
    to:'',
    type:2,
    img:'',
    introduce:'',
    status:0,
    params:{
      id:0
    },
    children:[
      {
        name:'招生计划',
        to:'/enroll/article/list',
        type:1,
        params:{
          category_id:3
        },
      },
      {
        name:'收费一览',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:18
        },
      },
      {
        name:'录取程序',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:2
        },
      },
      {
        name:'证书样本',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:16
        },
      },
    ],
  },
  {
    name:'招生动态',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:7
    },
  },
  {
    name:'网上报名',
    to:'/sign',
    type:3,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:8
    },
  },
  {
    name:'常见问答',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:9
    },
  },
  {
    name:'资料下载',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:10
    },
  },
  {
    name:'联系我们',
    to:'/enroll/article/content',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      article_id:13
    },
  },
  {
    name:'学校首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{
    },
    img:'',
    introduce:''
  },
];
export default {
  column,
  enrollColumn
}



// WEBPACK FOOTER //
// ./src/utils/params.js